<template>
    <div class="d-flex justify-content-center align-items-center mt-4">
        <div class="d-flex flex-column org-settings-card p-4 col-3" :class="loading ? 'justify-content-center' : ''">
            <ProgressSpinner v-if="loading" class="progress-spinner"/>
            <div v-else>
                <div class="d-flex flex-column kt-font-lg my-3">
                    <div class="d-flex flex-column align-items-center mt-2">
                        <div>
                            <div>
                                {{ $t('AppOrganizationSettingsCard.Fusos horários') }}
                            </div>
                            <div class="px-1 mt-1">
                                <Dropdown v-model="selectedTimezone" :options="TIMEZONES" filter class="input-width"
                                          :placeholder="$t('AppOrganizationSettingsCard.Selecione o fuso')"/>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3 mx-5 kt-font-md">
                        <div class="d-flex flex-column col-5">
                            <div class="font-weight-bold mb-1">
                                {{ $t('AppOrganizationSettingsCard.Horário UTC') }}
                            </div>
                            <div>
                                {{ dateHourFormat(currentTime, 'UTC') }}
                            </div>
                        </div>
                        <div class="d-flex flex-column col-7">
                            <div class="font-weight-bold mb-1">
                                {{ !selectedTimezone ? $t('AppOrganizationSettingsCard.Selecione um fuso para verificar seu horário') : selectedTimezone }}
                            </div>
                            <div v-if="selectedTimezone">
                                {{ dateHourFormat(currentTime, selectedTimezone) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-4">
                    <Button :label="$t('AppOrganizationSettingsCard.Salvar')" @click="updateOrganization"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dateHourFormat from '../../../mixins/DateMixin';
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import moment from 'moment';
import ProgressSpinner from "primevue/progressspinner";

export default {
    mixins: [dateHourFormat],
    mounted() {
        this.interval = setInterval(this.updateCurrentTime, 1000);
        this.TIMEZONES = moment.tz.names();
        this.setData();
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    data() {
        return {
            TIMEZONES: [],
            selectedTimezone: null,
            interval: null,
            currentTime: null
        }
    },
    props: {
        organization: {
            type: Object,
            required: true
        },
        gettingData: {
            type: Boolean
        }
    },
    methods: {
        setData() {
            this.selectedTimezone = this.organization.zone_offset
        },
        updateCurrentTime() {
            this.currentTime = parseInt(Date.now() / 1000)
        },
        updateOrganization() {
            if(this.currentValues){
                this.$toast.add({
                    severity: 'warn',
                    summary: this.$t('AppOrganizationSettings.O formulário não possui alterações!'),
                    life: 5000
                });
                return
            }

            this.$emit('save', this.selectedTimezone)
        }
    },
    watch: {
        organization: function() {
            this.setData();
        }
    },
    computed: {
        loading: function () {
            return !this.currentTime || this.gettingData;
        },
        currentValues: function () {
            return this.organization.zone_offset === this.selectedTimezone
        }
    },
    components: {
        ProgressSpinner, Button, Dropdown, InputText
    }
}
</script>

<style scoped>
.org-settings-card {
    background: white;
    border-radius: 1rem;
}

.input-width {
    width: 330px;
}

.card-divider {
    border-bottom: lightgrey 1px dashed;
    width: 70%;
}

.progress-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 4rem;
}
</style>
